import { useRouter } from 'next/router'
import { Trans } from 'next-i18next'

import {
  Heading3,
  LinkText,
  Paragraph,
  Section3
} from '@/features/Listings/seo/elements'
import useFilterSlug from '@/features/Listings/seo/search-results-content/content/use-filter-slug'

const AverageRentTemp = ({ filterSlug, cityName, neighborhoodName }) => {
  const router = useRouter()
  const isChinese = router.locale === 'zh'
  const { hasFilter, filterName } = useFilterSlug(filterSlug)

  return (
    <Section3>
      <Heading3>
        {hasFilter ? (
          <Trans
            i18nKey="seo:What is the average rent near LOCATION for FILTER?"
            values={{
              filter: filterName,
              location: neighborhoodName
            }}
            defaults="What is the average rent near {{ location }} for {{ filter }}?"
          />
        ) : (
          <Trans
            i18nKey="seo:What is the average rent near LOCATION?"
            values={{
              location: neighborhoodName
            }}
            defaults="What is the average rent near {{ location }}?"
          />
        )}
      </Heading3>
      <Paragraph>
        {hasFilter ? (
          <Trans i18nKey="seo:Average Rent near LOCATION for FILTER Paragraph 2">
            The average rent near {{ neighborhoodName }} for {{ filterName }}{' '}
            will vary on a month-to-month basis. We will soon be adding{' '}
            <LinkText
              href={
                isChinese
                  ? 'https://liv.rent/blog/zh/%E7%A7%9F%E9%87%91%E7%BB%9F%E8%AE%A1/'
                  : 'https://liv.rent/blog/rent-reports/'
              }
            >
              {{ cityName }} rent reports
            </LinkText>{' '}
            so stay tuned for stats on the average rent near{' '}
            {{ neighborhoodName }}.
          </Trans>
        ) : (
          <Trans i18nKey="seo:Average Rent near LOCATION Paragraph 2">
            The average rent near {{ neighborhoodName }} will vary on a
            month-to-month basis. We will soon be adding{' '}
            <LinkText
              href={
                isChinese
                  ? 'https://liv.rent/blog/zh/%E7%A7%9F%E9%87%91%E7%BB%9F%E8%AE%A1/'
                  : 'https://liv.rent/blog/rent-reports/'
              }
            >
              {{ cityName }} rent reports
            </LinkText>{' '}
            so stay tuned for stats on the average rent near{' '}
            {{ neighborhoodName }}.
          </Trans>
        )}
      </Paragraph>
    </Section3>
  )
}

export default AverageRentTemp
